const state = []

const mutations = {
  setAnswer (state, payload) {
    const answered = state.findIndex(o => o.id === payload.id)
    answered > -1 ? state[answered] = payload : state.push(payload)
  },
  // função para dar o clear
  clearAnswers (state) {
    state = []
  }
}

const getters = {
  getAnswersList: state => state
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
